module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "gameGrade"
  }, [(_vm.level == 1) ? _c('ul', [_c('li', {
    staticStyle: {
      "background-color": "#1BBE9F"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.level == 2) ? _c('ul', [_c('li', {
    staticStyle: {
      "background-color": "#7ED321"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#7ED321"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.level == 3) ? _c('ul', [_c('li', {
    staticStyle: {
      "background-color": "#F6A623"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#F6A623"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#F6A623"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.level == 4) ? _c('ul', [_c('li', {
    staticStyle: {
      "background-color": "#F67023"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#F67023"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#F67023"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#F67023"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.level == 5) ? _c('ul', [_c('li', {
    staticStyle: {
      "background-color": "#D62720"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#D62720"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#D62720"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#D62720"
    }
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "background-color": "#D62720"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06b8314a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/levels.vue
// module id = 941
// module chunks = 2